export class AddressDto {
	id: number;
	address: string = '';
	zipCode: string = '';
	city: string = '';
}
